import { Add, Delete, Edit } from "@material-ui/icons";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ContentState, EditorState } from "draft-js";
import {
  deleteApplicationKind,
  fetchApplicationKinds,
} from "../../../services/applicationKindsService";
import { useEffect, useState } from "react";

import CreateDialog from "./CreateDialog";
import CustomAlert from "../../components/CustomAlert";
import CustomEditor from "../../components/Editor";
import CustomTable from "../../components/Table";
import DeleteDialog from "../../components/CustomDeleteDialog";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import UpdateDialog from "./UpdateDialog";
import htmlToDraft from "html-to-draftjs";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../../hooks/useLocale";
import { useQuery } from "react-query";
import GovGrButton from "../../../components/GovGrButton";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const useStyles = makeStyles({
  viewDetails: {
    width: 700,
    height: 400,
  },
});

const ApplicationKinds = () => {
  const { t } = useLocale();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [details, setDetails] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [editorState, setEditorState] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, isError, isLoading, refetch } = useQuery(
    "applicationKinds",
    fetchApplicationKinds
  );
  const classes = useStyles();
  useEffect(() => {
    setEditorState(() => {
      let contentBlock = null;
      if (details) {
        contentBlock = htmlToDraft(details);
      }
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const newEditorState = EditorState.createWithContent(contentState);
        return newEditorState;
      }
    });
  }, [details]);

  return (
    <>
      <Helmet title={t("Application Kinds")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Application Kinds")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>
        <Link component={NavLink} exact to="/parameters">
          {t("Parameters")}
        </Link>
        <Typography>{t("Application Kinds")}</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <CustomAlert
        open={isError}
        close={() => {
          refetch();
        }}

        message={t("A network error occured, please try again later")}
      />

      <CustomTable
        isLoading={isLoading}

        columns={[
          {
            title: t("Code"),
            field: "cd",
            width: "50px",
          },
          {
            title: t("Description"),
            field: "dscr",
          },
          {
            title: t("Details"),
            field: "details",
            render: (rowData) => (
              <GovGrButton
                disabled={rowData.details === null}
                onClick={() => {
                  setDetails(rowData.details);
                  setIsModalOpen(true);
                }}
                buttonText={t("View")}
              />
            ),
          },
        ]}
        data={data}
        actions={[
          // {
          //   icon: () => <Add />,
          //   tooltip: t("Add"),
          //   isFreeAction: true,
          //   onClick: () => {
          //     setIsCreateDialogOpen(true);
          //   },
          // },
          {
            icon: () => <Edit htmlColor="#1E90FF" />,
            tooltip: t("Edit"),
            onClick: (event, rowData) => {
              setIsUpdateDialogOpen(true);
              setSelectedItem(rowData);
            },
          },
          {
            icon: () => <Delete htmlColor="#B22222" />,
            tooltip: t("Delete"),
            onClick: (event, rowData) => {
              setIsDeleteDialogOpen(true);
              setSelectedItem(rowData);
            },
          },
        ]}
      />
      <Dialog
        maxWidth="lg"
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <DialogTitle id="details-dialog-title">
          {t("Application Kind Details")}
        </DialogTitle>
        <DialogContent className={classes.viewDetails}>
          <CustomEditor toolbarHidden readOnly editorState={editorState} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsModalOpen(false);
            }}
          >
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>

      <CreateDialog
        open={isCreateDialogOpen}
        close={() => setIsCreateDialogOpen(false)}
        refetch={refetch}
      />

      <UpdateDialog
        open={isUpdateDialogOpen}
        close={() => setIsUpdateDialogOpen(false)}
        refetch={refetch}
        selectedItem={selectedItem}
      />
      <DeleteDialog
        title={t("Delete Application Kind")}
        message={t(
          "Are you sure you want to delete the selected Application Kind"
        )}
        fieldName="dscr"
        open={isDeleteDialogOpen}
        close={() => setIsDeleteDialogOpen(false)}
        refetch={refetch}
        selectedItem={selectedItem}
        deleteService={deleteApplicationKind}
      />
    </>
  );
};

export default ApplicationKinds;
